module.exports = __webpack_public_path__ + "static/media/talksCardBack.0288c5ec.svg";